<ion-content>
  <ion-grid *ngIf="stage==='login'">
    <ion-row class="title-login">
      <ion-col size="2"></ion-col>
      <ion-col>
        <h2>Login</h2>
      </ion-col>
      <ion-col (click)="dimiss()" size="2" class="close-icon">
        <img src="../../../assets/icon/close.svg" alt="close"/>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-item lines="none" class="each-input">
          <ion-input labelPlacement="stacked" placeholder="Email" (ngModelChange)="emailError=null" [(ngModel)]="email">
            <ion-icon slot="start" aria-hidden="true" src="/assets/icon/mail.svg"></ion-icon>
          </ion-input>
          <span class="input-error" *ngIf="emailError">{{emailError}}</span>
        </ion-item>
        <ion-item lines="none" class="each-input">
          <ion-input labelPlacement="stacked" type="password" placeholder="Trade Code" (ngModelChange)="tradeCodeError=null" [(ngModel)]="tradeCode">
            <ion-icon slot="start" aria-hidden="true" src="/assets/icon/lock.svg"></ion-icon>
          </ion-input>
          <span class="input-error" *ngIf="tradeCodeError">{{tradeCodeError}}</span>
        </ion-item>

        <span class="forget-pass" (click)="stage='forget'">Forget Trade Code?</span>

<!--        <app-captcha [reload]="recaptchaReload" [Captcha]="captcha" [InputError]="captchaError" (InputChanged)="captchaUserInputChanged($event)" (getCaptcha)="CaptchaReceived($event)"></app-captcha>-->

        <ion-row class="submit-auth">
          <ion-col>
            <ion-button [disabled]="loadingLogin" (click)="login()" color="primary">{{loadingLogin ? '' : 'Login'}}
              <ion-spinner *ngIf="loadingLogin"></ion-spinner>
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <p style="color: var(--ion-color-primary);text-align: center;margin: 27px;cursor: pointer;" (click)="openRegister()">Don't have access? Sign up</p>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid *ngIf="stage==='forget'">
    <ion-row class="title-login">
      <ion-col  class="back-icon" size="2" (click)="stage='login'">
        <img src="../../../assets/icon/back-form.svg" alt="back"/>
      </ion-col>
      <ion-col>
        <h2>Forget Code</h2>
      </ion-col>
      <ion-col (click)="dimiss()" size="2" class="close-icon">
        <img src="../../../assets/icon/close.svg" alt="close"/>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <p class="forget-p">
          Enter the email address you used to register, and we'll send you a link to recover your code.
        </p>
      </ion-col>
      <ion-col>
        <ion-item lines="none" class="each-input">
          <ion-input [(ngModel)]="forgetEmail" (ngModelChange)="forgetEmailError=null;" labelPlacement="stacked" placeholder="Email address">
            <ion-icon slot="start" aria-hidden="true" src="/assets/icon/mail.svg"></ion-icon>
          </ion-input>
          <span class="input-error" *ngIf="forgetEmailError">{{forgetEmailError}}</span>
        </ion-item>
      </ion-col>
    </ion-row>
<!--    <app-captcha [reload]="recaptchaReloadForget" [Captcha]="captchaForget" [InputError]="captchaErrorForget" (InputChanged)="captchaUserInputChangedForget($event)" (getCaptcha)="CaptchaReceivedForget($event)"></app-captcha>-->
    <ion-row class="submit-auth">
      <ion-col>
        <ion-button [disabled]="loadingForget" (click)="sendForgetCode()" color="primary">{{loadingForget ? '' : 'Submit'}}
          <ion-spinner *ngIf="loadingForget" name="dots"></ion-spinner>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid *ngIf="stage==='send_forget'">
    <ion-row class="title-login">
      <ion-col class="back-icon" size="2">
      </ion-col>
      <ion-col>
        <h2>Forget Code</h2>
      </ion-col>
      <ion-col size="2" class="close-icon">
        <img src="../../../assets/icon/close.svg" alt="close"/>
      </ion-col>
    </ion-row>
    <ion-row class="done-forget">
      <ion-col>
        <div class="icon-forget">
          <img src="../../../assets/img/forget.png" alt="forget code"/>
        </div>
        <p>Please check your email inbox and confirm the link. If you don't see the
          email, check your spam folder. Need another link?</p>
        <b class="resend-btn" (click)="stage='forget'">Resend?</b>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
